import { SYSTEM_MESSAGE } from '../consts/text/system-msg';

export const randomHashStr = (size = 6) => {
    return Math.random().toString(36).substring(2, size);
};

export const getErrorByMensage = (mensage, e, status) => {
    const isErrorMensage = e?.response?.data?.erros?.some(
        (err) => err?.titulo === mensage,
    );
    if (status) return e?.response?.status === status && isErrorMensage;
    return isErrorMensage;
};

export const getMensageError = (e, isDetalhe) => {
    const mensage = e?.response?.data?.erros?.reduce((acc, i) => {
        const men = isDetalhe ? i?.detalhe : i?.titulo;
        if (men) return acc?.concat(` ${men}`);
        return acc;
    }, '');
    return mensage || SYSTEM_MESSAGE.ERRO_AO_SE_COMUNICAR;
};
